<template>
  <div
    class="basic_button height_fill"
    @mouseenter="module_isHover(true)"
    @mouseleave="module_isHover(false)"
    :style="{
      height: module.data.pc_widgets_infor.height + 'px'
    }"
  >
    <div class="tooptipPart">
      <template v-if="$store.state.app.view_pattern === 'pc'" class="module_edit_btn">
        <my_edit_btn :module="module" :title="$t('widgets_basic_button_index_451')"></my_edit_btn>
        <my_edit_btn :module="module" tabName="animation"></my_edit_btn>
        <my_link_btn :module="module" :title="$t('widgets_basic_button_index_452')"></my_link_btn>
        <my_close_btn :module="module" :column="column" :moduleIndex="module_index" :title="$t('widgets_basic_button_index_453')"></my_close_btn>
      </template>
    </div>
    <div
      class="buttonContent"
      @mouseenter="changeData(true)"
      @mouseleave="changeData(false)"
      :class="module.data.pc_widgets_infor.styleType"
      :style="{
        height: '100%',
        '--borderSeColor': borderSeColor,
        '--borderColor': borderColor,
        '--backgroundColor': backgroundColor,
        '--backgroundSeColor': backgroundSeColor,
        '--fontColor': fontColor,
        '--fontSeColor': fontSeColor,
        borderStyle:
          module.data.pc_widgets_infor.border.radio_val !== 'hidden' ? module.data.pc_widgets_infor.border[module.data.pc_widgets_infor.border.radio_val].borderStyle : '',
        borderWidth:
          module.data.pc_widgets_infor.border.radio_val !== 'hidden' ? module.data.pc_widgets_infor.border[module.data.pc_widgets_infor.border.radio_val].borderWidth + 'px' : 0,
        borderRadius: module.data.pc_widgets_infor.borderRadius[module.data.pc_widgets_infor.borderRadius.radio_val].value + 'px'
      }"
    >
      <div class="bothHeight">
        <span class="btnLink" @dblclick="clickTime">
          <set_link class="linkPart" :sendData="module.data.listArr.link" v-if='module.widgets_id !== editID'></set_link>
          <div
            class="edit-div btnWords"
            :contenteditable="$store.state.app.view_pattern === 'pc'"
            :id="'editDiv' + module.widgets_id"
            @mousedown.stop
            @focus="isLocked = true"
            @blur="isLocked = false"
            @input="changeText"
            v-html="module.data.listArr.title"
            :style="{
              fontSize: module.data.pc_widgets_infor.font[module.data.pc_widgets_infor.font.radio_val].fontSize + 'px',
              fontFamily: module.data.pc_widgets_infor.font[module.data.pc_widgets_infor.font.radio_val].fontFamily,
              lineHeight: module.data.pc_widgets_infor.height + 'px',
              fontWeight: module.data.pc_widgets_infor.fontStyle.custom.fsWeight,
              fontStyle: module.data.pc_widgets_infor.fontStyle.custom.fsItalics,
              textDecoration: module.data.pc_widgets_infor.fontStyle.custom.fontUnderline,
              webkitBackgroundClip: 'text',
              webkitTextFillColor: hoverWords
                ? module.data.pc_widgets_infor.font[module.data.pc_widgets_infor.font.radio_val].sePattern == 'linear_gradient'
                  ? 'transparent'
                  : ''
                : module.data.pc_widgets_infor.font[module.data.pc_widgets_infor.font.radio_val].pattern == 'linear_gradient'
                ? 'transparent'
                : '',
              color: hoverWords
                ? module.data.pc_widgets_infor.font[module.data.pc_widgets_infor.font.radio_val].sePattern == 'pure_color'
                  ? module.data.pc_widgets_infor.font[module.data.pc_widgets_infor.font.radio_val].fontSeColor
                  : ''
                : module.data.pc_widgets_infor.font[module.data.pc_widgets_infor.font.radio_val].pattern == 'pure_color'
                ? module.data.pc_widgets_infor.font[module.data.pc_widgets_infor.font.radio_val].fontColor
                : '',
              backgroundImage: hoverWords
                ? module.data.pc_widgets_infor.font[module.data.pc_widgets_infor.font.radio_val].sePattern == 'linear_gradient'
                  ? 'linear-gradient(' +
                    module.data.pc_widgets_infor.font[module.data.pc_widgets_infor.font.radio_val].seLinear_gradient.deg +
                    'deg,' +
                    module.data.pc_widgets_infor.font[module.data.pc_widgets_infor.font.radio_val].seLinear_gradient.start_color +
                    module.data.pc_widgets_infor.font[module.data.pc_widgets_infor.font.radio_val].seLinear_gradient.start_pointer +
                    '%,' +
                    module.data.pc_widgets_infor.font[module.data.pc_widgets_infor.font.radio_val].seLinear_gradient.end_color +
                    module.data.pc_widgets_infor.font[module.data.pc_widgets_infor.font.radio_val].seLinear_gradient.end_pointer +
                    '%)'
                  : ''
                : module.data.pc_widgets_infor.font[module.data.pc_widgets_infor.font.radio_val].pattern == 'linear_gradient'
                ? 'linear-gradient(' +
                  module.data.pc_widgets_infor.font[module.data.pc_widgets_infor.font.radio_val].linear_gradient.deg +
                  'deg,' +
                  module.data.pc_widgets_infor.font[module.data.pc_widgets_infor.font.radio_val].linear_gradient.start_color +
                  module.data.pc_widgets_infor.font[module.data.pc_widgets_infor.font.radio_val].linear_gradient.start_pointer +
                  '%,' +
                  module.data.pc_widgets_infor.font[module.data.pc_widgets_infor.font.radio_val].linear_gradient.end_color +
                  module.data.pc_widgets_infor.font[module.data.pc_widgets_infor.font.radio_val].linear_gradient.end_pointer +
                  '%)'
                : ''
            }"
          ></div>
          <!-- <my_div_edit
            :value.sync="module.data.listArr.title"
            :module="module"
            @input="saveWrods"
            :style="{
              fontSize: module.data.pc_widgets_infor.font[module.data.pc_widgets_infor.font.radio_val].fontSize + 'px',
              fontFamily: module.data.pc_widgets_infor.font[module.data.pc_widgets_infor.font.radio_val].fontFamily,
              lineHeight: module.data.pc_widgets_infor.height + 'px',
              webkitBackgroundClip: 'text',
              webkitTextFillColor: hoverWords
                ? module.data.pc_widgets_infor.font[module.data.pc_widgets_infor.font.radio_val].sePattern == 'linear_gradient'
                  ? 'transparent'
                  : ''
                : module.data.pc_widgets_infor.font[module.data.pc_widgets_infor.font.radio_val].pattern == 'linear_gradient'
                ? 'transparent'
                : '',
              color: hoverWords
                ? module.data.pc_widgets_infor.font[module.data.pc_widgets_infor.font.radio_val].sePattern == 'pure_color'
                  ? module.data.pc_widgets_infor.font[module.data.pc_widgets_infor.font.radio_val].fontSeColor
                  : ''
                : module.data.pc_widgets_infor.font[module.data.pc_widgets_infor.font.radio_val].pattern == 'pure_color'
                ? module.data.pc_widgets_infor.font[module.data.pc_widgets_infor.font.radio_val].fontColor
                : '',
              backgroundImage: hoverWords
                ? module.data.pc_widgets_infor.font[module.data.pc_widgets_infor.font.radio_val].sePattern == 'linear_gradient'
                  ? 'linear-gradient(' +
                    module.data.pc_widgets_infor.font[module.data.pc_widgets_infor.font.radio_val].seLinear_gradient.deg +
                    'deg,' +
                    module.data.pc_widgets_infor.font[module.data.pc_widgets_infor.font.radio_val].seLinear_gradient.start_color +
                    module.data.pc_widgets_infor.font[module.data.pc_widgets_infor.font.radio_val].seLinear_gradient.start_pointer +
                    '%,' +
                    module.data.pc_widgets_infor.font[module.data.pc_widgets_infor.font.radio_val].seLinear_gradient.end_color +
                    module.data.pc_widgets_infor.font[module.data.pc_widgets_infor.font.radio_val].seLinear_gradient.end_pointer +
                    '%)'
                  : ''
                : module.data.pc_widgets_infor.font[module.data.pc_widgets_infor.font.radio_val].pattern == 'linear_gradient'
                ? 'linear-gradient(' +
                  module.data.pc_widgets_infor.font[module.data.pc_widgets_infor.font.radio_val].linear_gradient.deg +
                  'deg,' +
                  module.data.pc_widgets_infor.font[module.data.pc_widgets_infor.font.radio_val].linear_gradient.start_color +
                  module.data.pc_widgets_infor.font[module.data.pc_widgets_infor.font.radio_val].linear_gradient.start_pointer +
                  '%,' +
                  module.data.pc_widgets_infor.font[module.data.pc_widgets_infor.font.radio_val].linear_gradient.end_color +
                  module.data.pc_widgets_infor.font[module.data.pc_widgets_infor.font.radio_val].linear_gradient.end_pointer +
                  '%)'
                : ''
            }"
            class="btnWords"
          ></my_div_edit> -->
          <span
            class="after"
            :style="{
              borderRadius: module.data.pc_widgets_infor.borderRadius[module.data.pc_widgets_infor.borderRadius.radio_val].value + 'px'
            }"
          ></span>

        </span>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

export default {
  name: 'basic_navbar',
  data() {
    return {
      isHover: false,
      hoverWords: false,
      isLocked: false
      //backgroundColor: '',
      //backgroundSeColor: '',
      //fontColor: '',
      //fontSeColor: '',
      //borderColor: '',
      //borderSeColor: ''
    };
  },

  props: {
    module: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    module_index: {
      type: Number,
      default: 0
    }
  },
  created() {
    this.templet.checkfontStyle(this.module.data.pc_widgets_infor)
  },
  computed: {
    borderColor() {
      const infor = this.module.data.pc_widgets_infor;
      return infor.border[infor.border.radio_val].borderColor;
    },
    borderSeColor() {
      const infor = this.module.data.pc_widgets_infor;
      return infor.border[infor.border.radio_val].borderSeColor;
    },
    backgroundColor() {
      const infor = this.module.data.pc_widgets_infor;
      const background =
        infor.background[infor.background.radio_val].pattern == 'linear_gradient'
          ? 'linear-gradient(' +
            infor.background[infor.background.radio_val].linear_gradient.deg +
            'deg,' +
            infor.background[infor.background.radio_val].linear_gradient.start_color +
            infor.background[infor.background.radio_val].linear_gradient.start_pointer +
            '%,' +
            infor.background[infor.background.radio_val].linear_gradient.end_color +
            infor.background[infor.background.radio_val].linear_gradient.end_pointer +
            '%)'
          : infor.background[infor.background.radio_val].color;
      return background;
    },
    backgroundSeColor() {
      const infor = this.module.data.pc_widgets_infor;
      const background =
        infor.background[infor.background.radio_val].sePattern == 'linear_gradient'
          ? 'linear-gradient(' +
            infor.background[infor.background.radio_val].seLinear_gradient.deg +
            'deg,' +
            infor.background[infor.background.radio_val].seLinear_gradient.start_color +
            infor.background[infor.background.radio_val].seLinear_gradient.start_pointer +
            '%,' +
            infor.background[infor.background.radio_val].seLinear_gradient.end_color +
            infor.background[infor.background.radio_val].seLinear_gradient.end_pointer +
            '%)'
          : infor.background[infor.background.radio_val].seColor;
      return background;
    },
    fontColor() {
      const infor = this.module.data.pc_widgets_infor;
      return infor.font[infor.font.radio_val].fontColor;
    },
    fontSeColor() {
      const infor = this.module.data.pc_widgets_infor;
      return infor.font[infor.font.radio_val].fontSeColor;
    },
    isMobile() {
      return this.$store.state.app.view_pattern === 'mb';
    },
    isPc() {
      return this.$store.state.app.view_pattern === 'pc';
    },
    editID() {
      if (this.$store.state.app.module_Data) {
        return this.$store.state.app.module_Data.widgets_id;
      } else {
        return 0;
      }
    }
  },
  watch: {
    isLocked(val) {
      let htmlWord = $(`#u${this.module.widgets_id} .edit-div`).html();
      this.module.data.listArr.title = htmlWord;
      console.log(this.module.data.listArr.title);
      if (val) {
        var range = document.createRange();
        range.selectNodeContents(document.getElementById('editDiv' + this.module.widgets_id));
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
      } else if (!val) {
        window.getSelection().removeAllRanges();
        $('#u' + this.module.widgets_id)
          .find('.contentPart')
          .removeClass('focusDiv');
        // this.templet.dialog_close()
      }
    },
  },
  methods: {
    changeText(val) {
      this.$store.state.app.is_change = true
    },
    clickTime() {
      let that = this;
      if (this.module.widgets_id === this.editID) {
        return false;
      }
      if(this.$store.state.app.view_pattern !== 'pc'){
        return false;
      }
      $('#u' + that.module.widgets_id)
        .find('.contentPart')
        .addClass('focusDiv');
      var range = document.createRange();
      range.selectNodeContents(document.getElementById('editDiv' + this.module.widgets_id));
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
    },
    changeData(val) {
      this.hoverWords = val;
    },
    module_isHover(val) {
      this.isHover = val;
    },
    saveWrods(data) {
      this.module.data.listArr.title = data;
    }
  },
  mounted() {
  }
};
</script>

<style lang="scss" scoped>
.basic_button:hover {
  .tooptipPart {
    display: block;
  }
}
.basic_button {
  height: 100%;
  .tooptipPart {
    right: 0;

    display: none;
  }
  .tooptipPart:hover {
    display: block;
  }
  .buttonContent {
    transition: all 0.6s;
    background: var(--backgroundColor);
  }
  .btnLink {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 100%;
    color: #000;
    cursor: pointer;
    white-space: nowrap;
    text-decoration: none;
    text-align: center;
    vertical-align: middle;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-transition: all 0.3s;
    -o-transition: all 0.3s;
    -moz-transition: all 0.3s;
    transition: all 0.3s;
    -webkit-transform-style: preserve-3d;
    -moz-transform-style: preserve-3d;
    transform-style: preserve-3d;
    .linkPart {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }
    .after {
      pointer-events: none;
    }
  }
}
.basic_button .btnLink  .btnWords {
  height: unset;
  text-align: center;
  cursor: pointer;
  white-space: nowrap;
  min-width: 10px;
  overflow: hidden;
  display: block;
  width: 100%;
  position: relative;
  outline: 0;
  margin: 0 8px;
}
.basic_button .buttonContent.type_0 {
  border-radius: 4px;
  border-color: var(--borderColor);
  color: var(--fontColor);
  position: relative;
  background: var(--backgroundColor);
  .after {
    display: block;
    transition: all 0.6s;
    width: 100%;
    height: 0;
    border-radius: 50%;
    left: 50%;
    top: 50%;
    padding-top: 100%;
    position: absolute;
    z-index: 0;
    transform: translateX(-50%) translateY(-50%);
  }
}

.basic_button .buttonContent.type_0:hover {
  .after {
    -webkit-animation: button_style_0_anim 0.75s;
    -moz-animation: button_style_0_anim 0.75s;
    -o-animation: button_style_0_anim 0.75s;
    animation: button_style_0_anim 0.75s;
    z-index: 1;
  }
}

.basic_button .buttonContent.type_0:hover {
  color: var(--backgroundColor);
  background: var(--backgroundSeColor);
}
.basic_button .buttonContent.type_1 {
  border-radius: 20px;
  color: var(--fontColor);
  position: relative;
  background: var(--backgroundColor);
  border: 1px solid var(--borderColor);
}
.basic_button .buttonContent.type_1:hover {
  color: var(--backgroundColor);
  background: var(--backgroundSeColor);
}
.basic_button .buttonContent.type_2 {
  border-radius: 4px;
  color: var(--fontColor);
  border-color: var(--borderColor);
}

.basic_button .buttonContent.type_2:hover {
  color: var(--backgroundColor);
  background: var(--backgroundSeColor);
}
.basic_button .buttonContent.type_3 {
  border-radius: 20px;
  background: var(--backgroundColor);
  border-width: 1px;
  border-style: solid;
  border-color: var(--borderColor);
}

/*.basic_button .basic_button .buttonContent.type_3{
  background: #fff;
}*/
.basic_button .buttonContent.type_3:hover {
  color: var(--fontSeColor);
  border: 1px solid var(--borderSeColor);
  background: var(--backgroundSeColor);
}
.basic_button .buttonContent.type_4 {
  background: var(--backgroundColor);
  color: var(--fontColor);
  border: 1px solid var(--borderColor);
}
.basic_button .buttonContent.type_4:hover {
  color: var(--fontSeColor);
  background: var(--backgroundSeColor);
  border: 1px solid var(--borderSeColor);
}
.basic_button .buttonContent.type_5 {
  background: var(--backgroundColor);
  color: var(--fontColor);
  border: 1px solid var(--borderColor);
  position: relative;
  .btnWords {
    position: relative;
  }
  .after {
    display: block;
    width: 0%;
    height: 100%;
    background: var(--backgroundColor);
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    transition: all 0.3s;
    z-index: -1;
  }
}
.basic_button .buttonContent.type_5:hover {
  color: var(--fontSeColor);
  .btnWords {
    color: var(--fontSeColor);
  }
  .after {
    background: var(--backgroundSeColor);
    border: 1px solid var(--borderSeColor);
    opacity: 1;
    width: 100%;
  }
}
.bothHeight {
  height: 100%;
}

.basic_button .buttonContent:hover {
  color: var(--fontSeColor);
  background: var(--backgroundSeColor);
  border: 1px solid var(--borderSeColor);
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_button/index.vue